import { render, staticRenderFns } from "./MainDesktopNavigation.vue?vue&type=template&id=219ba6ef"
import script from "./MainDesktopNavigation.vue?vue&type=script&lang=js"
export * from "./MainDesktopNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports